// extracted by mini-css-extract-plugin
export var body = "terms-module--body--480e6";
export var section = "terms-module--section--5f8a9";